<div class="row">
    <div class="col-12">

        <form [formGroup]="videoForm">
            <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

                <aw-wizard-step stepTitle="TITOLO">
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="title">TITOLO*</label>
                                    <input formControlName="title" type="text" class="form-control" id="title" aria-describedby="title" placeholder="">
                                    <small id="titleHelp" class="form-text text-muted">Scrivi una titolo</small>
                                </div>
                                <div class="form-group">
                                    <label for="subtitle">DESCRIZIONE AGGIUNTIVA</label>
                                    <textarea  formControlName="subtitle" class="form-control" id="subtitle" aria-describedby="subtitleHelp"></textarea>
                                    <small id="subtitleHelp" class="form-text text-muted">Scrivi un sottotitolo o un indicazione aggiuntiva</small>
                                </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateTitle()" (click)="setTitle()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="CONTENUTO">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="hasImage">VUOI INSERIRE UN'IMMAGINE?</label>
                                <div class="switch m-r-10">
                                    <input type="checkbox" id="hasImage" formControlName="hasImage" aria-describedby="hasImageHelp">
                                    <label for="hasImage" class="cr"></label>
                                </div>
                                <small id="hasImageHelp" class="form-text text-muted">La Interaction prevede un'immagine?</small>
                            </div>
                            <div class="form-group" *ngIf="f.hasImage.value">
                                <label>IMMAGINE</label>
                                <app-media-manager [filePath]="interaction.image" (onFileSelect)="setImageUrl($event, 'featuredImage')"></app-media-manager>
                            </div>
                            <div class="form-group">
                                <label for="description">LINK VIDEO</label>
                                <input formControlName="link" type="text" class="form-control" id="link" aria-describedby="link" placeholder="youtube o vimeo link">
                                <small id="descriptionHelp" class="form-text text-muted">Aggiungi il link al video.</small>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateContenuto()" (click)="onAddInteraction()">Salva</button>
                        </div>
                    </div>
                </aw-wizard-step>
            
            </aw-wizard>
        </form>
    </div>
</div>

<!-- {{interaction | json}} -->